var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#21A6E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4 24.1239L14.71 24.0699L13.9 24.0519C13.288 24.0399 12.826 24.0279 12.514 24.0159C11.998 23.9799 11.542 23.9199 11.146 23.8359C10.606 23.7159 10.18 23.4579 9.868 23.0619C9.616 22.7379 9.43 22.2999 9.31 21.7479C9.238 21.4119 9.172 20.9019 9.112 20.2179L9.094 20.1099C8.914 17.9019 8.992 15.7419 9.328 13.6299C9.424 13.0299 9.658 12.5589 10.03 12.2169C10.402 11.8749 10.882 11.6799 11.47 11.6319C14.95 11.3919 18.946 11.3559 23.458 11.5239C23.734 11.5239 24.148 11.5719 24.7 11.6679C25.312 11.7759 25.786 12.0459 26.122 12.4779C26.398 12.8379 26.596 13.3239 26.716 13.9359C26.8 14.2959 26.866 14.8539 26.914 15.6099L26.932 15.8439C27.076 17.5599 27.016 19.3179 26.752 21.1179C26.68 21.6819 26.578 22.1319 26.446 22.4679C26.29 22.8879 26.074 23.2179 25.798 23.4579C25.474 23.7219 25.054 23.8719 24.538 23.9079C23.278 23.9919 22.258 24.0519 21.478 24.0879C20.362 24.1359 19.342 24.1539 18.418 24.1419C18.418 24.1299 18.412 24.1239 18.4 24.1239ZM16.24 20.4699C16.924 20.0619 17.944 19.4619 19.3 18.6699L20.83 17.7699L16.24 15.0699V20.4699Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 9 26.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.86fc730c52231673e1c27e98d25a5949.svg";
export { ForwardRef as ReactComponent };